<div class="generic--error container" role="main">
  @if (config?.img) {
    <img [src]="config?.img" alt="Error" data-test-id="genericErrorImage" />
  }
  <h1
    class="GenericError__Title"
    [innerHTML]="config?.header?.title"
    data-test-id="errorMessageTitle"
  ></h1>
  <p data-test-id="errorMessageSubtitle">{{ config?.header?.subtitle }}</p>

  @if (config?.buttons) {
    <div class="generic--error__buttons u-flex u-alignCenter u-justifyBetween">
      @for (button of config?.buttons; track button) {
        <zip-button
          [level]="button.level"
          (zipButtonClicked)="onAction.emit(button.prop)"
          [content]="button.content"
          data-test-id="errorMessageButton"
        >
        </zip-button>
      }
    </div>
  }
</div>

@if (config?.footer) {
  <div class="generic--error__footer">
    <div class="container">
      <div class="u-flex u-justifyEnd">
        @for (button of config?.footer.buttons; track button) {
          <zip-button
            [level]="button.level"
            (zipButtonClicked)="onAction.emit(button.prop)"
            [content]="button.content"
            data-test-id="GenericErrorfooterButton"
          >
          </zip-button>
        }
      </div>
    </div>
  </div>
}
